import { alpha } from '@material-ui/core/styles';
import { styled } from '../../../../../../core/theme/styled';
import { Text } from '../../../../../atoms/Text/Text';

export const StyledCheckmark = styled.svg`
  width: 0.75rem;
  height: 0.625rem;
  stroke: rgb(255, 255, 255);
  stroke-width: 1.5;
  fill: none;
  pointer-events: none;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  line-height: 1.5;
  position: relative;

  input[type='checkbox'] {
    /* reset checkbox styles */
    appearance: none;
    margin: 0;
    outline: none;
    color: rgba(0, 0, 0, 0.54);
    position: absolute;
    top: 1.1rem;
    left: 1rem;
    height: 1.25rem;
    width: 1.25rem;
    border-radius: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.08) 0 2px 4px 0;
    background-color: #fff;
    border: 1px solid;
  }

  input[type='checkbox']:checked {
    background-color: ${(props) => props.theme.configuration.buttonBackgroundColor};
    border-color: ${(props) => props.theme.configuration.buttonBackgroundColor};
  }

  ${StyledCheckmark} {
    position: absolute;
    top: 1.4rem;
    left: 1.3rem;
    opacity: 0;
  }

  label {
    display: block;
    border: 1px solid ${(props) => props.theme.configuration.strokeColor};
    border-radius: ${(props) => props.theme.roundedCorners.xsmall};
    padding: ${(props) => props.theme.sizes.small} ${(props) => props.theme.sizes.normal};
    padding-left: 2.8rem;
    background-color: ${(props) => props.theme.configuration.backgroundColor};
    color: ${(props) => props.theme.configuration.primaryTextColor};
    cursor: pointer;
    box-shadow: none;
    transition: box-shadow 0.2s ease-in-out;
    width: 100%;
  }

  label ${Text} {
    margin-top: ${(props) => props.theme.sizes.xxxsmall};
  }

  label:hover {
    box-shadow: ${(props) => props.theme.shadows.small};
  }

  input:checked ~ label {
    border-color: ${(props) => props.theme.configuration.buttonBackgroundColor};
    box-shadow: ${(props) => props.theme.shadows.large};
  }

  input:checked ~ ${StyledCheckmark} {
    opacity: 1;
  }

  input:focus ~ label,
  input:active ~ label {
    box-shadow: 0 0 0 3px ${(props) => alpha(props.theme.configuration.primaryColor, 0.25)};
  }
`;
